export const GET_INVENTORY_APPROVAL = 'GET_INVENTORY_APPROVAL';
export const GET_INVENTORY_APPROVAL_SUCCESS = 'GET_INVENTORY_APPROVAL_SUCCESS';
export const GET_INVENTORY_APPROVAL_FAILED = 'GET_INVENTORY_APPROVAL_FAILED'; 

export const GET_INVENTORY_APPROVAL_BY_ID = 'GET_INVENTORY_APPROVAL_BY_ID';
export const GET_INVENTORY_APPROVAL_BY_ID_SUCCESS = 'GET_INVENTORY_APPROVAL_BY_ID_SUCCESS';
export const GET_INVENTORY_APPROVAL_BY_ID_FAILED = 'GET_INVENTORY_APPROVAL_BY_ID_FAILED'; 

export const ACCEPT_REJECT_APPROVAL = 'ACCEPT_REJECT_APPROVAL';
export const ACCEPT_REJECT_APPROVAL_SUCCESS = 'ACCEPT_REJECT_APPROVAL_SUCCESS';
export const ACCEPT_REJECT_APPROVAL_FAILED = 'ACCEPT_REJECT_APPROVAL_FAILED'; 